import { Space as AntSpace, SpaceProps } from 'antd';
import cn from 'classnames';
import styles from './Space.module.scss';

const Space: React.FC<SpaceProps> = (props) => {
	return <AntSpace {...props} className={cn(props.className, styles.root)} />;
};

export default Space;
